<template>
	<div>
		<!-- 第二导航栏 -->
		<PageHeader />
		<!-- 主要内容区 -->
		<main>
			<router-view />
		</main>
		<!-- 底部栏 -->
		<CommonFooter />
	</div>
</template>

<script>
	import PageHeader from '@/components/PageHeader.vue'
	import CommonFooter from '@/components/CommonFooter.vue'
	export default {
		name: 'Layout',
		components: {
			PageHeader,
			CommonFooter
		},
		methods: {}
	}
</script>

<style scoped>
	
</style>